import $ from "jquery";
import TIP from "./tip";

export default class Partnership {
    constructor() {
        const dataElement = document.querySelector("div#data");
        if (dataElement) {
            this.config = dataElement.dataset;

            this.partner = {
                tip: new TIP(
                    { add: this.config.partnerAdd, delete: null },
                    this.initPartnerLinkAutocomplete.bind(this),
                    this.createBlockElement("div"),
                ),
                element: document.querySelector("div.partner"),
            };

            this.children = {
                tip: new TIP(
                    { add: this.config.childrenAdd, delete: null },
                    this.initChildAutocomplete.bind(this),
                    this.createBlockElement("div"),
                ),
                collection: document.querySelector("div.children"),
            };

            this.init();
            this.bindEvents();
        }
    }

    createBlockElement(tag) {
        const element = document.createElement(tag);
        element.setAttribute("class", "bs-light dfs-bloc pt-1 pb-2 mt-1 p-r");

        return element;
    }

    init() {
        this.children.tip.initFormCollection(
            this.children.collection,
            "child",
            false,
        );
    }

    bindEvents() {

        document.querySelector("body").addEventListener("click", (event) => {
            if (event.target.classList.contains("toggle-tree")) {
                event.preventDefault();
                if(event.target.classList.contains("active")) {
                    let toggleShowText = event.target.attributes['data-toggle-text'].nodeValue;
                    let toggleHideText = event.target.textContent;
                    event.target.textContent = toggleShowText;
                    event.target.attributes['data-toggle-text'].nodeValue = toggleHideText;
                    event.target.parentNode.querySelector("p.tree-toggle").innerHTML = "";
                    event.target.classList.remove("active");
                }
                else {
                    const childCompany = event.target.parentNode.querySelector("select").value;
                    $.get(event.target.attributes.href.value, {"partnerId": childCompany}).then(data => {
                        event.target.parentNode.querySelector("p.tree-toggle").innerHTML = data;
                        let toggleHideText = event.target.attributes['data-toggle-text'].nodeValue;
                        let toggleShowText = event.target.textContent;
                        event.target.textContent = toggleHideText;
                        event.target.attributes['data-toggle-text'].nodeValue = toggleShowText;
                        event.target.classList.add("active");
                    });
                }
            }
        });
    }

    initPartnerLinkAutocomplete(newBlock) {
        newBlock.querySelectorAll("[rel='autocomplete']").forEach(element => {
            this.partner.tip.initSelect2(element);
        });
    }

    initChildAutocomplete(newBlock) {
        newBlock.querySelectorAll("[rel='autocomplete']").forEach(element => {
            this.children.tip.initSelect2(element);
        });
    }
}
